import React from "react";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import Packages from "@/sections/Packages";
import HowItWorks from "@/sections/HowItWorks";
import About from "@/sections/About";
import FAQ from "@/sections/FAQ";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-brand-cream text-brand-dark min-h-screen">
            <Header />
            <Hero />
            <Marquee />
            <Services />
            <Packages />
            <HowItWorks />
            <About />
            <FAQ />
            <Contact />
            <Footer />
        </main>
    );
}
